<template>
  <div class="p-5">
    <div class="flex justify-end -mt-16 mb-3">
      <div class="w-1/6">
        <multiselect
          :value="selectedYear"
          :option="periode"
          :value-t="selectedYear"
          height="51px"
          icon-height="20"
          :icon="icons.calendar"
          @info="handleYearChange"
          class=""
        />
      </div>
    </div>
    <div ref="chart" class="h-full" />
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import http from "@/plugins/https";
import apiroutes from "../../../router/api-routes";
import store from "../../../store";
import multiselect from "../../helper/form/multiselect.vue";
import calendar from "../../../assets/icons/calendar.svg";

export default {
  name: "StackedBarChart",
  components: { multiselect },
  data() {
    return {
      stats: [],
      charge: false,
      categories: [],
      values: [],
      chartInstance: null,
      icons: {
        calendar,
      },
      periode: Array.from({ length: 11 }, (_, i) => `${new Date().getFullYear() - i}`),
      selectedYear: `${new Date().getFullYear()}`,
    };
  },

  created() {
    this.getData();
  },

  methods: {
    handleYearChange(event) {
      const newValue = event?.target?.value || event;
      console.log("Changement manuel de l’année :", newValue);
      this.selectedYear = newValue;
      this.getData();
    },

    getData() {
      const year = this.selectedYear;
      http.defaults.headers.common.Authorization = "Bearer " + store.getters.token;
      http
        .post(apiroutes.baseURL + apiroutes.get_stats_signup, {
          apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
          startDate: `01/01/${year}`,
          endDate: `12/31/${year}`,
        })
        .then((response) => {
          this.stats = response.data;
          this.charge = false;
          this.renderChart();
          console.log(response);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération des données :", error);
          this.charge = false;
        });
    },

    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      const categories = this.stats.map((item) => item.mois);
      const values = this.stats.map((item) => item.total);

      const options = {
        series: [
          {
            name: "Données Mensuelles",
            data: values,
            color: "#64C877",
          },
        ],
        chart: {
          type: "bar",
          height: 400,
          stacked: true,
          stackType: "0%",
          toolbar: {
            show: false,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 90,
              },
            },
          },
        ],
        xaxis: {
          categories: categories,
          labels: {
            show: true,
          },
        },
        yaxis: {
          labels: {
            show: true,
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "right",
          offsetX: 0,
          offsetY: 50,
          show: false,
        },
      };

      this.chartInstance = new ApexCharts(this.$refs.chart, options);
      this.chartInstance.render();
    },
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>
